/**
 * @description Object used to build a notification component
 */
export class NotificationBuilder {
    constructor(icon = null, title = "Notification", description = "", className = "") {
        this.id = Date.now();

        this.icon = icon;
        this.title = title;
        this.description = description;

        this.isPermanent = false;
        this.className = className;
    }

    withIcon(icon) {
        this.icon = icon;

        return this;
    }

    withTitle(title) {
        this.title = title;

        return this;
    }

    withDescription(description) {
        this.description = description;

        return this;
    }

    withClassStyle(className) {
        this.className = className;

        return this;
    }

    withPermanency(isPermanent) {
        this.isPermanent = isPermanent;

        return this;
    }
}
